import {IWidgetControllerConfig} from '@wix/native-components-infra/dist/src/types/types'

export const instanceGetter = (controller: IWidgetControllerConfig) => {
  let instance = controller.appParams.instance
  controller.wixCodeApi.site.onInstanceChanged(event => (instance = event.instance))
  return () => instance
}
